import type { TFunction } from 'i18next'
import { formatDate, formatTime } from '../../lib/datetime'
import type { AgendaSeries } from './types'

/**
 * Seri özeti (126): "Her hafta · 29.12.2026 tarihine kadar". Tarih saatle verilir — yalnız tarih içeren
 * dizge UTC gece yarısı okunur ve batıdaki dilimlerde bir gün geri kayardı.
 */
export function recurrenceSummary(t: TFunction, series: AgendaSeries): string {
  return t('agenda.recurrence.summary', {
    frequency: t(`agenda.recurrence.every.${series.type}`),
    date: formatDate(`${series.endDate}T00:00:00`),
  })
}

/**
 * Toplantı zamanı tek satırda: aynı günse `GG.AA.YYYY SS:DD–SS:DD`, değilse iki uç da tarihli.
 * Değerler bölgesiz duvar saatidir; `new Date` onları yerel okur, dilim dönüşümü olmaz.
 */
export function formatAgendaWhen(startTime: string, endTime: string): string {
  const startDay = startTime.slice(0, 10)
  const endDay = endTime.slice(0, 10)
  if (startDay === endDay) {
    return `${formatDate(startTime)} ${formatTime(startTime)}–${formatTime(endTime)}`
  }
  return `${formatDate(startTime)} ${formatTime(startTime)} – ${formatDate(endTime)} ${formatTime(endTime)}`
}
